/* age-gate.js: full-screen age gate overlay. Edit CONFIG below. API: AgeGate.show(), AgeGate.isVerified(), AgeGate.reset() */
(function () {
  'use strict';

  var script = document.currentScript || {};
  var data = script.dataset || {};

  var CONFIG = {
    age: parseInt(data.age, 10) || 21,
    days: data.days !== undefined ? parseInt(data.days, 10) : 30,
    exitUrl: data.exitUrl || 'https://www.google.com/',
    cookie: 'bnk_age_ok',
    // One YES covers bignosekate.co and shop.bignosekate.co. Ignored on any other host (previews, staging).
    cookieDomain: '.bignosekate.co',
    // Size of one layout unit. '1rem' follows the site; set data-rem="16px" on themes
    // that shrink the root font size (most Shopify themes use 62.5%).
    rem: data.rem || '1rem',
    // Optional: URL of a RomanaBT-Bold .woff2 for sites that don't already load the font.
    fontUrl: data.fontUrl || '',
    klaviyo: { companyId: 'XmrCmd', listId: 'U34SqM', revision: '2026-01-15' },
    images: {
      logo: 'https://bignosekate.co/wp-content/uploads/2022/09/BNK_Nav_Logo-1.svg',
      top: 'https://bignosekate.co/wp-content/uploads/2021/08/BNK_Web_Boarder_UP.png',
      topMobile: 'https://bignosekate.co/wp-content/uploads/2021/08/BNK_Web_Boarder_UP_Mobile.png',
      bottom: 'https://bignosekate.co/wp-content/uploads/2021/08/BNK_Web_Boarder_Down.png',
      bottomMobile: 'https://bignosekate.co/wp-content/uploads/2021/08/BNK_Web_Boarder_Down_Mobile.png'
    }
  };

  var ROOT_ID = 'bnk-age-gate';
  var LOCK_CLASS = 'bnk-age-locked';
  var BOTS = /bot|crawl|spider|slurp|facebookexternalhit|embedly|quora link|pinterest|lighthouse|pagespeed/i;

  /* ---------- persistence ---------- */

  function isVerified() {
    return document.cookie.split('; ').indexOf(CONFIG.cookie + '=1') !== -1;
  }

  function domainAttr() {
    var d = CONFIG.cookieDomain;
    if (!d) return '';
    var bare = d.replace(/^\./, '');
    var host = location.hostname;
    var match = host === bare || host.slice(-(bare.length + 1)) === '.' + bare;
    return match ? '; domain=' + d : '';
  }

  function remember() {
    var c = CONFIG.cookie + '=1; path=/; SameSite=Lax' + domainAttr();
    if (CONFIG.days > 0) c += '; max-age=' + CONFIG.days * 86400;
    if (location.protocol === 'https:') c += '; Secure';
    document.cookie = c;
  }

  function reset() {
    document.cookie = CONFIG.cookie + '=; path=/; max-age=0';
    document.cookie = CONFIG.cookie + '=; path=/; max-age=0' + domainAttr();
  }

  /* ---------- styles ---------- */
  // Colors and headline font are the custom properties at the top.
  // Button text inherits the site's body font.

  var CSS = [
    '#', ROOT_ID, '{',
      '--gate-rem:__REM__;',
      '--gate-bg:rgb(249,87,51);',
      '--gate-fg:#20232a;',
      '--gate-cream:#f3ecd3;',
      '--gate-olive:#6b5f3a;',
      '--gate-headline-font:"RomanaBT-Bold",Georgia,serif;',
      'position:fixed;inset:0;z-index:2147483647;font-size:1rem;line-height:1.4;box-sizing:border-box;',
      'display:flex;flex-direction:column;justify-content:space-between;align-items:center;',
      'background:var(--gate-bg);color:var(--gate-fg);',
      'text-align:center;overflow-y:auto;opacity:1;transition:opacity .35s ease;',
    '}',
    '#', ROOT_ID, '.is-leaving{opacity:0;pointer-events:none;}',
    '#', ROOT_ID, ' .gate-border{display:block;width:100%;flex:none;line-height:0;}',
    '#', ROOT_ID, ' .gate-border img{display:block;width:100%;height:auto;}',
    '#', ROOT_ID, ' .gate-body{flex:1 0 auto;display:flex;flex-direction:column;align-items:center;justify-content:center;',
      'width:100%;box-sizing:border-box;padding:clamp(1rem,3vh,2.5rem) 1.5rem;}',
    '#', ROOT_ID, ' .gate-logo{width:clamp(180px,23vw,300px);height:auto;margin:0 0 clamp(1.25rem,4.5vh,3.25rem);}',
    '#', ROOT_ID, ' h1{margin:0;color:inherit;font-family:var(--gate-headline-font);font-weight:normal;',
      'font-size:clamp(1.6rem,4.1vw,3.4rem);line-height:1.15;letter-spacing:.01em;text-transform:uppercase;}',
    '#', ROOT_ID, ' p{margin:clamp(.6rem,1.6vh,1.1rem) 0 0;color:inherit;font-family:var(--gate-headline-font);font-weight:normal;',
      'font-size:clamp(1.05rem,1.9vw,1.5rem);line-height:1.2;letter-spacing:.22em;text-transform:uppercase;}',
    '#', ROOT_ID, ' .gate-actions{display:flex;gap:clamp(.75rem,2.4vw,1.9rem);justify-content:center;',
      'width:100%;margin-top:clamp(1.25rem,4.5vh,3rem);}',
    '#', ROOT_ID, ' button{appearance:none;-webkit-appearance:none;cursor:pointer;box-sizing:border-box;',
      'flex:1 1 0;min-width:0;max-width:14.75rem;height:3.5rem;padding:0 0 0 .3em;margin:0;',
      'border:3px solid var(--gate-fg);border-radius:0;background:transparent;color:var(--gate-fg);box-shadow:none;',
      'font:inherit;font-size:.95rem;font-weight:500;line-height:1;letter-spacing:.3em;text-transform:uppercase;',
      'transition:background-color .2s ease,color .2s ease;}',
    '#', ROOT_ID, ' .gate-signup{width:min(100%,23rem);margin:clamp(1.5rem,5vh,3.25rem) 0 0;padding:0;}',
    '#', ROOT_ID, ' .gate-signup label{display:block;margin:0 0 .6rem;font-family:var(--gate-headline-font);',
      'font-size:1.25rem;line-height:1.2;letter-spacing:0;text-transform:none;}',
    '#', ROOT_ID, ' .gate-signup-row{display:flex;width:100%;height:3.75rem;}',
    '#', ROOT_ID, ' .gate-signup input{flex:1 1 auto;min-width:0;height:100%;box-sizing:border-box;margin:0;padding:0 1rem 0 1.9rem;',
      'border:0;border-radius:0;box-shadow:none;background:var(--gate-cream);color:var(--gate-fg);',
      'font:inherit;font-size:1rem;letter-spacing:.02em;}',
    '#', ROOT_ID, ' .gate-signup input::placeholder{color:var(--gate-olive);opacity:1;}',
    '#', ROOT_ID, ' .gate-signup input:focus-visible{outline:3px solid var(--gate-fg);outline-offset:-3px;}',
    '#', ROOT_ID, ' .gate-signup button{flex:none;width:8.75rem;max-width:none;height:100%;padding:0;border:0;',
      'background:var(--gate-fg);color:var(--gate-cream);font-size:.95rem;letter-spacing:.04em;}',
    '#', ROOT_ID, ' .gate-signup button:hover{background:#335038;color:var(--gate-cream);}',
    '#', ROOT_ID, ' .gate-signup button:disabled{opacity:.6;cursor:default;}',
    '#', ROOT_ID, ' .gate-signup-msg{min-height:1.4em;margin:.6rem 0 0;font-family:inherit;font-size:.9rem;',
      'letter-spacing:.02em;text-transform:none;}',
    '#', ROOT_ID, ' button:hover{background:var(--gate-fg);color:var(--gate-bg);}',
    '#', ROOT_ID, ' button:focus-visible{outline:3px solid var(--gate-fg);outline-offset:4px;}',
    // While locked: no scrolling, and everything except the gate is hidden from
    // sight, the tab order and screen readers. Doubles as the anti-flash guard.
    'html.', LOCK_CLASS, '{overflow:hidden!important;background:rgb(249,87,51);}',
    'html.', LOCK_CLASS, ' body>*:not(#', ROOT_ID, '){visibility:hidden!important;}',
    '@media (max-width:767px){',
      '#', ROOT_ID, ' .gate-logo{width:clamp(150px,44vw,200px);}',
      '#', ROOT_ID, ' button{height:3.1rem;}',
      '#', ROOT_ID, ' .gate-signup label{font-size:1.1rem;margin-bottom:.45rem;}',
      '#', ROOT_ID, ' .gate-signup-row{height:3.1rem;}',
      '#', ROOT_ID, ' .gate-signup input{padding-left:1.1rem;}',
      '#', ROOT_ID, ' .gate-signup button{width:7.5rem;}',
    '}',
    '@media (prefers-reduced-motion:reduce){#', ROOT_ID, '{transition:none;}}'
  ].join('').replace(/(\d*\.?\d+)rem\b/g, 'calc($1*var(--gate-rem))').replace('__REM__', CONFIG.rem);

  if (CONFIG.fontUrl) {
    CSS = '@font-face{font-family:"RomanaBT-Bold";src:url("' + CONFIG.fontUrl + '") format("woff2");font-display:swap;}' + CSS;
  }

  function injectStyles() {
    if (document.getElementById(ROOT_ID + '-css')) return;
    var style = document.createElement('style');
    style.id = ROOT_ID + '-css';
    style.textContent = CSS;
    (document.head || document.documentElement).appendChild(style);
  }

  /* ---------- markup ---------- */

  function border(desktop, mobile) {
    return '<picture class="gate-border" aria-hidden="true">' +
      '<source media="(max-width: 767px)" srcset="' + mobile + '">' +
      '<img src="' + desktop + '" alt="">' +
      '</picture>';
  }

  function build() {
    var el = document.createElement('div');
    el.id = ROOT_ID;
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-labelledby', ROOT_ID + '-title');
    el.innerHTML =
      border(CONFIG.images.top, CONFIG.images.topMobile) +
      '<div class="gate-body">' +
        '<img class="gate-logo" src="' + CONFIG.images.logo + '" alt="Big Nose Kate">' +
        '<h1 id="' + ROOT_ID + '-title">You must be ' + CONFIG.age + ' to enter Kate\u2019s Saloon</h1>' +
        '<p>Are you?</p>' +
        '<div class="gate-actions">' +
          '<button type="button" data-answer="yes">Yes</button>' +
          '<button type="button" data-answer="no">No</button>' +
        '</div>' +
        '<form class="gate-signup" novalidate>' +
          '<label for="' + ROOT_ID + '-email">Sign up for our newsletter. 21+ only.</label>' +
          '<div class="gate-signup-row">' +
            '<input id="' + ROOT_ID + '-email" type="email" name="email" placeholder="E-Mail Address" autocomplete="email" required>' +
            '<button type="submit">Subscribe</button>' +
          '</div>' +
          '<p class="gate-signup-msg" role="status" aria-live="polite"></p>' +
        '</form>' +
      '</div>' +
      border(CONFIG.images.bottom, CONFIG.images.bottomMobile);

    el.addEventListener('click', function (e) {
      var btn = e.target.closest('button[data-answer]');
      if (!btn) return;
      if (btn.dataset.answer === 'yes') accept(el);
      else location.href = CONFIG.exitUrl;
    });

    el.querySelector('.gate-signup').addEventListener('submit', subscribe);

    return el;
  }

  /* ---------- newsletter (Klaviyo client API) ---------- */

  function subscribe(e) {
    e.preventDefault();
    var form = e.currentTarget;
    var input = form.querySelector('input');
    var btn = form.querySelector('button');
    var msg = form.querySelector('.gate-signup-msg');
    var email = input.value.trim();

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      msg.textContent = 'Enter a valid e-mail address.';
      input.focus();
      return;
    }

    btn.disabled = true;
    msg.textContent = '';

    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + CONFIG.klaviyo.companyId, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/vnd.api+json',
        'Accept': 'application/vnd.api+json',
        'revision': CONFIG.klaviyo.revision
      },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Age gate',
            profile: { data: { type: 'profile', attributes: { email: email } } }
          },
          relationships: { list: { data: { type: 'list', id: CONFIG.klaviyo.listId } } }
        }
      })
    }).then(function (res) {
      if (!res.ok) throw new Error('Klaviyo responded ' + res.status);
      form.querySelector('.gate-signup-row').style.display = 'none';
      msg.textContent = 'You\u2019re on the list.';
    }).catch(function (err) {
      if (window.console) console.error('[age-gate]', err);
      btn.disabled = false;
      msg.textContent = 'That didn\u2019t go through. Try again in a moment.';
    });
  }

  /* ---------- behaviour ---------- */

  function accept(el) {
    remember();
    document.documentElement.classList.remove(LOCK_CLASS);
    el.classList.add('is-leaving');
    var done = function () { if (el.parentNode) el.parentNode.removeChild(el); };
    el.addEventListener('transitionend', done);
    setTimeout(done, 500); // fallback if transitions are disabled
    document.dispatchEvent(new CustomEvent('agegate:verified'));
  }

  function mount() {
    if (document.getElementById(ROOT_ID)) return;
    var el = build();
    document.body.appendChild(el);
    el.querySelector('button[data-answer="yes"]').focus({ preventScroll: true });
  }

  function show() {
    injectStyles();
    document.documentElement.classList.add(LOCK_CLASS); // immediately — before <body> paints
    if (document.body) mount();
    else document.addEventListener('DOMContentLoaded', mount);
  }

  window.AgeGate = { show: show, isVerified: isVerified, reset: reset };

  var inThemeEditor = !!(window.Shopify && window.Shopify.designMode);

  if (!('manual' in data) && !inThemeEditor && !isVerified() && !BOTS.test(navigator.userAgent)) show();

  // Releases the pre-hide rule from Custom CSS (needed when this runs from the footer).
  document.documentElement.classList.add('bnk-age-ready');
})();
